import './ModelEditModal.scss';

export { default } from './ModelEditModal';
